"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMilitaryAddressConfig = exports.useRuralAddressConfig = exports.useAddressModalConfig = exports.useAddressModalTexts = exports.getCodesList = exports.splitStates = void 0;
const initializer_1 = require("../initializer");
__exportStar(require("./constants"), exports);
__exportStar(require("./types"), exports);
var features_1 = require("../features");
Object.defineProperty(exports, "splitStates", { enumerable: true, get: function () { return features_1.splitStates; } });
Object.defineProperty(exports, "getCodesList", { enumerable: true, get: function () { return features_1.getCodesList; } });
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "useAddressModalTexts", { enumerable: true, get: function () { return hooks_1.useAddressModalTexts; } });
const useAddressModalConfig_hook_1 = require("./hooks/useAddressModalConfig.hook");
const useRuralAddressConfig_hook_1 = require("./hooks/useRuralAddressConfig.hook");
const useMilitaryAddressConfig_hook_1 = require("./hooks/useMilitaryAddressConfig.hook");
const useAddressModalConfig = () => (0, useAddressModalConfig_hook_1.useAddressModalConfig)(initializer_1.API);
exports.useAddressModalConfig = useAddressModalConfig;
const useRuralAddressConfig = () => (0, useRuralAddressConfig_hook_1.useRuralAddressConfig)(initializer_1.API);
exports.useRuralAddressConfig = useRuralAddressConfig;
const useMilitaryAddressConfig = () => (0, useMilitaryAddressConfig_hook_1.useMilitaryAddressConfig)(initializer_1.API);
exports.useMilitaryAddressConfig = useMilitaryAddressConfig;
//# sourceMappingURL=index.js.map